import React from "react"

interface props {
    number: number | undefined
}
const NumberFormat: React.FC<props> = ( {number} ) => {

    if (number === undefined || number === 0) {
        return <>-</>
    }

    const newNumber = new Intl.NumberFormat(
        navigator.language || "nl-NL",
        {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }
    ).format(number);

    return <>{newNumber}</>
}

export default NumberFormat